import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';


import fondo from '../../assets/img/landingPage/fondo.png';
import icon_free from '../../assets/img/landingPage/freeIcon.svg'
import icon_expo from '../../assets/img/landingPage/expoIcon.svg'
import icon_dyn from '../../assets/img/landingPage/dynamicIcon.svg'

import features_1 from '../../assets/img/landingPage/vc/SourceControl_01.png'
import features_2 from '../../assets/img/landingPage/vc/SourceControl_02.png'
import features_3 from '../../assets/img/landingPage/vc/SourceControl_03.png'



import logo from '../../assets/img/logos/AVAPSourceControl-negativo.svg'
import dividerbg from '../../assets/img/landingPage/hexagono-horizonte.png'




import gradientbottom from '../../assets/img/landingPage/gradientbottom.png'
import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'


const VersionControlProduct = () => {
    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing" 
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >

                {/* Hero Section */}
                <section id="heroProduct" className="text-center pt-5">
                    <img
                        src={logo}
                        alt="Logo AVAP API Source Control"
                        className="img-fluid logo mw-100"
                    />
                    <h1 className="fl-title m-0 ">Efficient code repository and version tracking for APIs</h1>
                    <p className="fl-subtitle">
                        Track code evolution and easily identify version deployment <br /> across environments

                    </p>
                    <a className="glowBtn-dark fakeHide" href="#"><span className="btnInner">  Start with AVAP Cloud</span></a>
                </section>

                {/* Powerful API Platform */}
                <section className="container text-center pb-5">
                    <div className="row">
                        <div className="col">
                            {/* <p className="fl-subtitle mb-3">
                                Titulo
                            </p> */}
                            {/* <img
                                src="https://placehold.co/1026x423"
                                alt="Platform Placeholder"
                                className="img-fluid mt-4 mb-5"
                            /> */}
                            <p className="fl-subtitle mb-3">
                                Simplified code management for API development
                            </p>
                            <p className="fl-text">
                                AVAP API Source Control provides tools for creating and managing code repositories, tracking code evolution, and offering clear visibility of which code versions are deployed across different environments. It helps maintain organization and consistency.

                            </p>
                        </div>
                    </div>

                </section>

                {/* Features */}
                {/*            <section className="container pb-5">
                    <div className="row">
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_free} alt="" />
                                <p>Centralized System</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_dyn} alt="" />
                                <p>Backward Compatibility</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_expo} alt="" />
                                <p>Consistent Performance</p>
                            </div>
                        </div>
                    </div>
                </section> */}

                {/* Beyond a Proxy */}
                <section className="container py-5 gradient-d fl-br-20 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 text-center">
                            <img
                                src={features_1}
                                alt="Image of a code repository representing the organization and management of code for version control"
                                className="img-fluid"
                                style={{ width: '70%', height: 'auto' }}
                            />
                        </div>
                        <div className="col-md-6 pr-5">

                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Code Repository Management</h3>
                            <p className="fl-text">
                                Easily create and manage code repositories for API development. Centralize all your project files in one place, enabling organized collaboration and version control.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Comprehensive API Management */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 pl-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Version Tracking</h3>
                            <p className="fl-text">
                            Track and view different versions of your code across environments. AVAP API Source Control provides a clear overview of which version is deployed where, ensuring consistency.


                            </p>
                        </div>

                        <div className="col-md-6 text-center">
                            <img
                                src={features_2}
                                alt="Image of version tracking system in AVAP API Source Control."
                                className="img-fluid"
                                style={{ width: '70%', height: 'auto' }}
                            />
                        </div>
                    </div>

                </section>

                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">

                        <div className="col-md-6 text-center">
                            <img
                                src={features_3}
                                alt="Visual representation of code evolution showing the progression of changes and updates."
                                className="img-fluid"
                                style={{ width: '90%', height: 'auto' }}
                            />
                        </div>



                        <div className="col-md-6 pr-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Code Evolution Monitoring
                            </h3>
                            <p className="fl-text">
                            Monitor and manage the evolution of your API code with detailed insights into code changes. Keep track of development progress and maintain backward compatibility seamlessly.
                            </p>
                        </div>

                    </div>
                </section>

                <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Improved Collaboration
                                </p>
                                <p className="fl-text">
                                Centralized repositories enable teams to collaborate efficiently, streamlining the development process and ensuring smooth version control
                                    <br />
                                    &nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Enhanced Visibility
                                </p>
                                <p className="fl-text">
                                Track and monitor code versions across environments, improving clarity and minimizing confusion during development and deployment.

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Code Management
                                </p>
                                <p className="fl-text">
                                Easily manage code evolution, maintain consistency, and ensure smoother transitions between API versions.

                                </p>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Getting Started */}
                <div className="bottomWrapper position-relative d-flex justify-content-center">
                    <img src={gradientbottom} alt="" className="gradient gradientBottom" />
                </div>
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default VersionControlProduct;
